import React, { useState, useContext, useEffect, useRef } from 'react'
import SearchComp from './SearchComp'
import SavedSearch from './SavedSearch'
// import FilterPanel from '@/product/components/species/dynamic/common/FilterPanel/Filter'
import SortbyCom from './SortbyComp'
import { Button, Divider, SwipeableDrawer, Tooltip } from '@material-ui/core'
import { Drawer, Typography } from '@material-ui/core'
import { useFormik } from 'formik'
import Filters from '../Dashboard/MyAuctions/SortbyComp'
import AuthContext from '@/product/context/auth/authContext'
import Commoncomp from '../Dashboard/MyAuctions/SortbyComp'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory, Link } from 'react-router-dom'
import SEO from '@/utils/SEO'
import { initialSearchFunction } from '../../product/components/species/dynamic/common/FieldFunction'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { Filter, FilterList, ShowChart } from '@material-ui/icons'
import Banner from '../../custom/components/molecules/Banner'
import Loaders from '@/custom/components/molecules/Loaders'
import FilterPanel from '@/custom/components/organisms/DirectFilterPanel'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductContext from '@/product/context/product/productContext'
import { useMediaQuery } from 'react-responsive'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import commonContext from '@/custom/context/common/commonContext'

const Search = (props) => {
    const queryParams = new URLSearchParams(location.search)
    const fromPage = props.from
    const filterFields = props.filterFields
        ? props.filterFields
        : fromPage === 'auction'
        ? ['categorytypes', 'model', 'brand', 'organisation', 'locations']
        : []

    const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const { modelData } = useContext(commonContext)

    const authContext = useContext(AuthContext)
    const dynamicContext = useContext(DynamicContext)
    const { allAgencyAddress } = useContext(CustomCommonContext)
    const { getAllDynamicArray, dynamicValue } = dynamicContext
    const productContext = useContext(ProductContext)
    const { active_sorts, getAllActiveSorts } = productContext

    const [dynamicArray, setDynamicArray] = useState([])
    const [addressOptions, setAddressOptions] = useState([])
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [arrayValue, setArrayValue] = useState([])
    const [reload, setReload] = useState(false)
    const [keepAllOptions, setkeepAllOptions] = useState(false)
    const { user, isAuthenticated } = authContext
    const [show, setShow] = useState(false)
    const [initialUpdate, setInitialUpdate] = useState(false)
    const [update, setUpdate] = useState({})
    const [isFilterOpen, setFilterOpen] = useState(false)
    const [openFiler, setOpenFiler] = useState(props?.auctionid ? false : true)
    const [limit, setLimit] = useState(30)
    const history = useHistory()
    const [updated, setUpdated] = useState(false)
    const [state, setState] = useState({
        bottom: false,
    })
    const [customFilter, setCustomFilter] = useState({})
    useEffect(() => {
        if (props.customFilter) {
            setCustomFilter(props.customFilter)
        }
    }, [props.customFilter])
    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
        if (open) {
            modelData(true)
        } else {
            modelData(false)
        }
    }

    const isTab = useMediaQuery({
        query: '(max-width: 1024px)',
    })

    const userRef = useRef(user)

    useEffect(() => {
        userRef.current = user
    })
    const searchText = [
        {
            label: 'Search',
            name: 'Search',
            type: 'search',
            placeholder: `Search`,
            class: '',
            size: 'small',
            autoFocus: false,
        },
    ]
    const [auctionView, setAuctionView] = useState('Grid')
    const pageOptions = [
        {
            value: '15',
            show: '15 per page',
        },
        {
            value: '30',
            show: '30 per page',
        },
        {
            value: '45',
            show: '45 per page',
        },
    ]
    const sortShow = [
        {
            value: 'p.id, desc',
            show: 'Sort by : New Items Listed',
        },
        {
            value: 'cp.lotnumber, desc',
            show: 'Sort by : Lot # Descending',
        },
        {
            value: 3,
            show: 'Sort by : Current price low to high',
        },
        {
            value: 4,
            show: 'Sort by : Current price high to low',
        },
        {
            value: 'p.date_closed, asc',
            show: 'Sort by : Time remaining',
        },
        {
            value: 1,
            show: 'Sort by : Ending today',
        },
    ]

    const formikSearch = useFormik({
        initialValues: {
            limit: limit,
            page: 1,
            prev_page: 1,
            orderby: props.orderby ? props.orderby : 'p.date_closed, asc',
            order: '',
            // market_status: ['open', 'closed', 'sold', 'unsold'],
            market_status: props.market_status ? props.market_status : ['open'],
            noCondition: true,
            search_user_id: userRef.current?.id ? userRef.current.id : 0,
            auctionView: 'Grid',
            filters: {
                categorytypes: {
                    value: [],
                    type: 'array',
                    field: 'it.category_id',
                },
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title,it.lotnumber',
                },

                condition: {
                    value: [],
                    type: 'array',
                    field: 'it.conditionTypeId',
                },
                locations: {
                    value: [],
                    type: 'array',
                    field: 'it.lotlocation',
                },
                is_new: {
                    value: 0,
                    type: 'in',
                    field: 'p.is_new',
                },
                auctionid: {
                    value: props.auctionid ? props.auctionid : 1,
                    type: props.auctionid ? 'in' : 'greaterequal',
                    field: 'p.auctionid',
                },
                buynowid: {
                    value: [],
                    type: 'array',
                    field: 'p.buynow',
                },
                brand: {
                    value: [],
                    type: 'array',
                    field: 'it.brand_id',
                },
                model: {
                    value: [],
                    type: 'array',
                    field: 'it.model_id',
                },
                min_price: {
                    value: 0,
                    type: 'greaterequal',
                    field: 'p.wprice',
                },

                lot_id: {
                    value: '',
                    type: 'like',
                    field: 'p.id',
                },
                max_price: {
                    value: 0,
                    type: 'smallerequal',
                    field: 'p.wprice',
                },

                closing_date: {
                    value: '',
                    type: 'dateequal',
                    field: 'p.date_closed',
                },
            },
            // having: {
            //     future_active: {
            //         value: 0,
            //         type: 'in',
            //         field: 'future_active',
            //     },
            // },
        },
        // enableReinitialize: true,
    })

    const updateView = (data) => {
        setAuctionView(data)
    }

    useEffect(() => {
        const currentFilters = formikSearch.values.filters || {}
        const updatedFilters = { ...currentFilters }

        // Update filters from query params
        if (Object.keys(customFilter).length) {
            formikSearch.setFieldValue('filters', { ...updatedFilters, ...customFilter })
        } else if (queryParams) {
            Object.keys(currentFilters).forEach((filterKey) => {
                const paramValue = queryParams.get(filterKey)
                if (paramValue && paramValue !== 'undefined') {
                    const filter = currentFilters[filterKey]
                    if (filter.type === 'array') {
                        updatedFilters[filterKey] = {
                            ...filter,
                            value: paramValue.split(','),
                        }
                    } else {
                        if (updatedFilters[filterKey]) {
                            updatedFilters[filterKey] = {
                                ...filter,
                                value: paramValue,
                            }
                        }
                    }
                }
            })

            formikSearch.setFieldValue('filters', updatedFilters)
        }
    }, [location.search, customFilter])

    const searchinitialValues = {
        searchValue: '',
    }

    const clearSearchFilter = () => {
        formikSearch.values = {
            ...formikSearch.values,
            limit: limit,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                categorytypes: {
                    ...formikSearch.values.filters.categoryTypeId,
                    value: [],
                },
                // subCategory: {
                //     ...formikSearch.values.filters.subCategory,
                //     value: [],
                // },
                condition: {
                    ...formikSearch.values.filters.condition,
                    value: [],
                },

                lot_id: {
                    ...formikSearch.values.filters.lot_id,
                    value: '',
                },
                locations: {
                    ...formikSearch.values.filters.locations,
                    value: [],
                },
                region: {
                    ...formikSearch.values.filters.region,
                    value: [],
                },
                price: {
                    ...formikSearch.values.filters.price,
                    value: 0,
                },
                searchbar: {
                    ...formikSearch.values.filters.searchbar,
                    value: '',
                },
                auctionid: {
                    ...formikSearch.values.filters.auctionid,
                    value: [],
                },
                buynowid: {
                    ...formikSearch.values.filters.buynowid,
                    value: [],
                },
                min_price: {
                    ...formikSearch.values.filters.min_price,
                    value: 0,
                },
                max_price: {
                    ...formikSearch.values.filters.max_price,
                    value: 0,
                },
            },
        }
        formikSearch.handleReset()
        setUpdate(formikSearch)

        setShow(true)
    }

    useEffect(() => {
        getAllActiveSorts({
            market_status: props.market_status ? props.market_status : ['open'],
            // filterFields,
            filters: {
                categorytypes: {
                    value: [],
                    type: 'array',
                    field: 'it.category_id',
                },
                searchbar: {
                    value: '',
                    type: 'like',
                    // field: 'p.title,p.desc_proc,p.id,it.manufacturer,it.model_no',

                    field: 'p.title,it.lotnumber',
                },

                condition: {
                    value: [],
                    type: 'array',
                    field: 'it.conditionTypeId',
                },
                locations: {
                    value: [],
                    type: 'array',
                    field: 'it.lotlocation',
                },

                auctionid: {
                    value: props.auctionid ? props.auctionid : 1,
                    type: props.auctionid ? 'in' : 'greaterequal',
                    field: 'p.auctionid',
                },
                buynowid: {
                    value: [],
                    type: 'array',
                    field: 'p.buynow',
                },
                is_new: {
                    value:
                        queryParams && queryParams.get('is_new') && queryParams.get('is_new') == 1
                            ? 1
                            : '0',
                    type: 'in',
                    field: 'p.is_new',
                },
                model: {
                    value: [],
                    type: 'array',
                    field: 'it.model_id',
                },
                brand: {
                    value: [],
                    type: 'array',
                    field: 'it.brand_id',
                },
                min_price: {
                    value: 0,
                    type: 'greaterequal',
                    field: 'p.wprice',
                },

                lot_id: {
                    value: '',
                    type: 'like',
                    field: 'p.id',
                },
                max_price: {
                    value: 0,
                    type: 'smallerequal',
                    field: 'p.wprice',
                },

                closing_date: {
                    value: '',
                    type: 'dateequal',
                    field: 'p.date_closed',
                },
                ...customFilter,
            },
        })
    }, [customFilter])

    useEffect(() => {
        setInitialValues({})
        setInitialEmptyValues({})
        setInitialUpdate(false)

        if (arrayValue.length) {
            let mapValueArray = arrayValue
            let custom = {
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title,it.lotnumber',
                },
            }

            let show = initialSearchFunction(mapValueArray)
            setInitialValues({ ...custom, ...show })
            setInitialEmptyValues({ ...custom, ...show })
            setTimeout(() => {
                if (Object.keys(show).length) {
                    setInitialUpdate(true)
                    setReload(!reload)
                }
            }, 1000)
        } else {
            let custom = {
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title,it.lotnumber',
                },
            }
            setInitialValues(custom)
            setInitialEmptyValues(custom)
            setTimeout(() => {
                if (Object.keys(custom).length) {
                    setInitialUpdate(true)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [arrayValue])

    // useEffect(() => {
    //     if (isAuthenticated) {
    //         if (user && user.admin) {
    //             handleRedirectInternal(history, 'seller/auctions/open')
    //         }
    //     }
    // }, [isAuthenticated, user])

    const reviewData = [
        {
            enable: 1,
            apiKey: '63f46395ae8edf3f88bf4a42',
        },
    ]

    useEffect(() => {
        if (isFilterOpen) {
            setLimit(12)
        } else setLimit(15)
    }, [isFilterOpen])
    return (
        <div className={props?.theme?.isActive ? '' : 'searchParent'}>
            {initialUpdate ? (
                <div className="customContainer searchContainer">
                    {props?.theme?.isActive ? null : (
                        <Breadcrumbs aria-label="breadcrumb" className="customBreadcrumbs">
                            <Link to="/">Home</Link>/
                            <Typography color="textPrimary">
                                {/* {props.renderHeading(location.pathname.split('/')[2])} */}
                                Search
                            </Typography>
                        </Breadcrumbs>
                    )}
                    <SEO title="Search" url={window.location.href} />

                    <div
                        className={`${
                            props?.theme?.isActive ? 'searchTheme' : ''
                        } search d-flex flex-column align-items-start ${
                            isFilterOpen ? '' : 'filterClosed'
                        }`}
                    >
                        {props?.auctionid ? null : (
                            <h3 className="searchHeader mb-4">Search page</h3>
                        )}
                        {props?.auctionid ? (
                            <div className="d-flex mb-3 align-items-center" style={{ gap: '10px' }}>
                                <PrimaryButton onClick={() => setOpenFiler(!openFiler)}>
                                    <FilterList />
                                    Filter
                                </PrimaryButton>
                                <h4 className="m-0" style={{ fontWeight: '600', fontSize: '22px' }}>
                                    Auctions Assets
                                </h4>
                            </div>
                        ) : null}
                        <div className={`d-flex w-100 ${isFilterOpen ? '' : 'filterClosed'}`}>
                            <div className={openFiler ? 'searchLt' : 'd-none'}>
                                <div className="deskFilter">
                                    <FilterPanel
                                        formik={formikSearch}
                                        clearSearch={clearSearchFilter}
                                        keySearch={true}
                                        from={1}
                                        show={true}
                                        arrayValue={arrayValue}
                                        update={update}
                                        addressOptions={addressOptions}
                                        fromPage={'search'}
                                        searchName={
                                            props.searchName
                                                ? props.searchName
                                                : [
                                                      'categorytypes',
                                                      'model',
                                                      'brand',
                                                      'organisation',
                                                      'locations',
                                                  ]
                                        }
                                    />
                                </div>
                            </div>

                            <div className="searchRt">
                                {isTab ? (
                                    <div>
                                        <Button
                                            className="respFilterBtn mb-3"
                                            onClick={toggleDrawer('bottom', true)}
                                        >
                                            <span className="material-icons">tune</span> Filters
                                        </Button>
                                    </div>
                                ) : null}
                                {/* 
                            <SavedSearch
                                formikSearch={formikSearch}
                                fromVariable={'liveProducts'}
                                isvisible={true}
                            /> */}
                                <Commoncomp
                                    path={false}
                                    viewSwitch={false}
                                    resultPerPage={false}
                                    sortBy={false}
                                    formikSearch={formikSearch}
                                    setAuctionView={updateView}
                                    auctionDetails={props.auctionDetails}
                                    // sortShow={sortShow}
                                    fromVariable={'liveProducts'}
                                    pageOptions={pageOptions}
                                    search={true}
                                />
                                <SearchComp
                                    formikSearch={formikSearch}
                                    auctionDetails={props.auctionDetails}
                                    clearSearchFilter={clearSearchFilter}
                                    auctionView={auctionView}
                                    pagination={true}
                                    fromVariable={'liveProducts'}
                                    auctionid={props.auctionid}
                                />
                            </div>
                        </div>
                    </div>

                    <SwipeableDrawer
                        className="filterDrawer searchDrawer"
                        anchor={'bottom'}
                        open={state['bottom']}
                        disableBackdropTransition={!iOS}
                        disableDiscovery={iOS}
                        disableSwipeToOpen={false}
                        onClose={toggleDrawer('bottom', false)}
                        onOpen={toggleDrawer('bottom', true)}
                    >
                        <div className="filterDrawerInner">
                            <div className="fdTitle">
                                <h3>Refine your Search</h3>
                                <Button onClick={toggleDrawer('bottom', false)}>
                                    <span className="material-icons">close</span>
                                </Button>
                            </div>
                            {/* <Commoncomp
                                path={false}
                                viewSwitch={false}
                                resultPerPage={true}
                                sortBy={true}
                                formikSearch={formikSearch}
                                setAuctionView={updateView}
                                sortShow={sortShow}
                                fromVariable={'liveProducts'}
                                pageOptions={pageOptions}
                            /> */}
                            <Divider className="mb-3" />
                            <FilterPanel
                                formik={formikSearch}
                                clearSearch={clearSearchFilter}
                                keySearch={true}
                                from={1}
                                show={true}
                                arrayValue={arrayValue}
                                update={update}
                                addressOptions={addressOptions}
                                fromPage={'search'}
                                searchName={
                                    props.searchName
                                        ? props.searchName
                                        : [
                                              'categorytypes',
                                              'model',
                                              'brand',
                                              //   'organisation',
                                              //   'locations',
                                          ]
                                }
                                // formik={formikSearch}
                                // clearSearch={clearSearchFilter}
                                // from={1}
                                // show={show}
                                // arrayValue={arrayValue}
                                // update={update}
                                // addressOptions={addressOptions}
                            />
                        </div>
                    </SwipeableDrawer>
                </div>
            ) : (
                <div className="noGridLoader homeInitialLoader loaderSuspense">
                    <Loaders isLoading={true} name={'ads_banner'} />
                </div>
            )}
        </div>
    )
}
export default Search
